import { z } from 'zod'
import { myTicketsResponseSchema } from './ticket'

/** GET /api/tickets/mine: the viewer's tickets and whether they can go into Apple Wallet. */
export const myTicketsWithWalletResponseSchema = myTicketsResponseSchema.extend({
  walletEnabled: z.boolean(),
})

/** POST /api/tickets/{ticketId}/wallet-link: a link to the ticket's pass, valid for minutes. */
export const ticketWalletLinkResponseSchema = z.object({ url: z.string().url() })
export type TicketWalletLinkResponse = z.infer<typeof ticketWalletLinkResponseSchema>
